<template>
    <div class="container offset">
        
        <form action="">
            <div class="form-group">
                <label class="question-style pt-1">Data da Aplicação:</label>
                <input
                    v-model="date"
                    type="date"
                    class="form-control input-personal disabled-style"
                />
            </div>

            <div class="custom-form ">
                <div class="form-group">
                    <label class="question-style pt-1">Aplicador:</label>
                        <input 
                            v-model="aplicacaoInfo.aplicador" 
                            type="text"
                            class="form-control input-personal disabled-style"
                        />
                </div>
            </div>

            <div class="custom-form ">
                <div class="form-group">
                    <label class="question-style pt-1">Formulário:</label>
                        <input
                            v-model="aplicacaoInfo.form_name" 
                            type="text"
                            class="form-control input-personal disabled-style"
                        />
                </div>
            </div>

            <div class="custom-form ">
                <div class="form-group">
                    <label class="question-style pt-1">Unidade Educacional:</label>
                        <input
                            v-model="aplicacaoInfo.unidade" 
                            type="text"
                            class="form-control input-personal disabled-style"
                        />
                </div>
            </div>

            <div class="custom-form ">
                <div class="form-group">
                    <label class="question-style pt-1">Turma:</label>
                        <input
                            v-model="aplicacaoInfo.turma" 
                            type="text"
                            class="form-control input-personal disabled-style"
                        />
                </div>
            </div>

            <div class="custom-form ">
                <div class="form-group">
                    <label class="question-style pt-1">Período da turma:</label>
                        <input
                            v-model="aplicacaoInfo.periodo_turma" 
                            type="text"
                            class="form-control input-personal disabled-style"
                        />
                </div>
            </div>
            <!--
            <div class="custom-form ">
                <div class="form-group">
                        
                        <label class="question-style pt-1">Sorteio:</label>
                        <div class="form-check mr-3">
                            
                            <input class="form-check-input" type="radio" name="sorteio" id="sorteio_of" value="Oficial" required>
                            <label for="sorteio_of" class="form-check-label">Oficial</label>    
                        </div>

                        <div class="form-check mr-3">
                            
                            <input class="form-check-input" type="radio" name="sorteio" id="sorteio_subs" value="Substituta">
                            <label for="sorteio_subs" class="form-check-label">Substituta</label>
                        </div>
                </div>
            </div>
            -->
        </form>
        
    </div>
</template>

<script>
//import Button from '../../components/Button'
//import Swal from "sweetalert2";
export default {
    name: "AplicacaoInfo",
    components: {
        //Button
    },
    data() {
        return {
           aplicacaoInfo : '',
           date : '',
        };
    },
    props: {
        data: Object,
    },
    
    computed: {
    },
    
    watch: {
        
        data() {
            this.aplicacaoInfo = this.$props.data;
            if(this.aplicacaoInfo.data_aplicacao){
                this.date = this.aplicacaoInfo.data_aplicacao?.substring(0,10);
            }
        },
        
    },
    methods: {
        close() {
            this.$emit('closeModal')
        },
    },
    created(){ 
    }
};
</script>

<style scoped>

    .container{
        width: 100%;
        background-color: white;
    }

    .form-group{
        display: flex;
    }

    .question-style{
        width: 100%;
        font-size: 1rem;
        font-weight: 500;
        color: #656565;
    }

    .image-style{
        display: block;
        margin-left: auto;
        margin-right: auto;
        width: 50%;
        padding: 1rem;
    }

    .button-div{
        margin-top: 2rem;
    }

    .input-personal {
        padding: 0.2rem 0.4rem;
        font-size: 0.938rem;
        font-weight: 400;
        border-radius: 8px;
        background: #FCFCFC;
        outline: none;
        border: 1px solid rgba(0, 0, 0, 0.11);
        font-weight: lighter;
        padding: 0.2rem 0.4rem;
        box-shadow: 1px 2px 6px -3px rgb(0 0 0 / 25%);
    }

    .disabled-style{
        background-color: #D0D0D0 !important;
        cursor: default;
        pointer-events: none;
    }
</style>